var _rect, _line, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnNewCoverMiddleOf = function SvgIcnBtnNewCoverMiddleOf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.5,
    x2: 0.499999,
    y2: 15.5,
    stroke: "#DDDEE1",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5H6.875C5.83947 5 5 5.83947 5 6.875V13.125C5 14.1605 5.83947 15 6.875 15H13.125C14.1605 15 15 14.1605 15 13.125V6.875C15 5.83947 14.1605 5 13.125 5Z",
    stroke: "#57595E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92376 7.5C7.30451 7.5 6.75 7.94969 6.75 8.56761V9.03145C6.75 9.35849 7.04248 9.57626 7.33309 9.57626C7.62369 9.57626 7.91617 9.35849 7.91617 9.03145V8.5903C7.9183 8.5899 7.92082 8.58962 7.92376 8.58962H9.41469V11.9104H8.87417C8.58356 11.9104 8.29108 12.1281 8.29108 12.4552C8.29108 12.7822 8.58356 13 8.87417 13H11.1258C11.4164 13 11.7089 12.7822 11.7089 12.4552C11.7089 12.1281 11.4164 11.9104 11.1258 11.9104H10.5853V8.58962H12.0762C12.0792 8.58962 12.0817 8.5899 12.0838 8.5903V9.03145C12.0838 9.35849 12.3763 9.57626 12.6669 9.57626C12.9575 9.57626 13.25 9.35849 13.25 9.03145L13.25 8.56761L13.25 8.56513C13.2439 7.95444 12.6927 7.5 12.0718 7.5H7.92376Z",
    fill: "#57595E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnNewCoverMiddleOf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_new_cover_middle_of.8023d945.svg";
export { ForwardRef as ReactComponent };